import React from 'react';
import { Document } from '../types';
import DoctorCard from './DoctorCard';
import LocationCard from './LocationCard';

interface IProps {
	posts: Array<Document>;
	setLoadingHeight?: (height: number | null) => void;
}

const PostsGrid = ({ posts, setLoadingHeight }: IProps) => {
	if (posts.length) {
		return (
			<div className={`fd-posts-grid`}>
				{posts.map((post) => {
					switch (post.document_location.type) {
						case 'finda_location': {
							return <LocationCard post={post} key={post.document_location.id} />;
						}
						default: {
							return <DoctorCard post={post} key={post.document_location.id} />;
						}
					}
				})}
			</div>
		);
	}

	return <></>;
};

export default PostsGrid;
